export var _mainLabelTheme = {
  baseStyle: {
    label: {
      display: 'contents',
      color: 'neutral.black',
      _readOnly: {
        color: 'neutral.darker',
        cursor: 'default'
      },
      _disabled: {
        color: 'neutral.light'
      }
    },
    placeholder: {
      textStyle: 'body2',
      display: 'contents',
      color: 'neutral.darker'
    },
    secondaryLabel: {
      textStyle: 'body2',
      color: 'neutral.black',
      _readOnly: {
        color: 'neutral.darker',
        cursor: 'default'
      },
      _disabled: {
        color: 'neutral.light'
      }
    },
    iconIndicator: {
      display: 'inline-flex',
      color: 'neutral.black',
      _readOnly: {
        color: 'neutral.darker',
        cursor: 'default'
      },
      _disabled: {
        color: 'neutral.light'
      }
    }
  },
  variants: {
    default: _ref => {
      var {
        size
      } = _ref;
      return {
        label: {
          textStyle: size === 'small' ? 'body3' : 'body2'
        }
      };
    },
    bold: _ref2 => {
      var {
        size
      } = _ref2;
      return {
        label: {
          textStyle: size === 'small' ? 'body3Semi' : 'body2Semi'
        }
      };
    }
  }
};
//# sourceMappingURL=_MainLabel.theme.js.map